/*
 * ${locale}.resources.${resourceName}.name for resource names (used for the menu and page titles)
 * ${ locale }.resources.${ resourceName }.fields.${ fieldName } for field names(used for datagrid header and form input labels)
 */

export default {
    'unauthorised-action': 'Questa è un’azione non autorizzata',
    actions: {
        add: 'Inserisci',
        cancel: 'Annulla',
        close: 'Vicino',
        create: 'Creare',
        configure: 'Configura',
        confirm: 'Confermare',
        deduct: 'Dedotto',
        delete: 'Elimina',
        duplicate: 'Duplicare',
        edit: 'Modificare',
        export: 'Esporta',
        generated: 'Generato',
        goBack: 'Ritornare',
        hide: 'Nascondere',
        import: 'Importa',
        invite: 'Invitare',
        list: 'Elenco',
        no: 'No',
        ok: 'Ok',
        pause: 'Pausa',
        refresh: 'Ricaricare',
        refund: 'Rimborso',
        reset: 'Valori chiari',
        resume: 'Riprendere',
        retry: 'Riprova',
        returnTo: 'Ritornare a',
        returnToThe: 'Ritorna al',
        save: 'Salvare',
        search: 'Ricerca',
        show: 'Mostrare',
        signIn: 'registrati',
        submit: 'Sottoscrivi',
        submit_add_another: 'Salva e aggiungi il prossimo',
        terminate: 'Terminare',
        translate: 'Tradurre',
        yes: 'Sì',
    },
    auth: {
        forgotPassword: {
            actions: {
                iRemember: 'Io ricordo',
                resetPassword: 'Resetta la password',
            },
            fields: {
                email: 'E-mail',
            },
            notifications: {
                success: 'Se potessimo trovare il tuo account, riceverai una mail a breve.',
            },
            title: 'Hai dimenticato la password?',
        },
        login: {
            fields: {
                email: 'E-mail',
                password: 'Parola d’ordine',
            },
            notifications: {
                failure: 'Credenziali non valide',
            },
            noCookies: {
                description: 'I cookie non sono abilitati sul tuo browser. Abilita i cookie nelle preferenze del tuo browser per continuare.',
                title: 'Cookie richiesti',
            },
        },
        logout: {
            description: 'Sei sicuro di voler effettuare il logout?',
            title: 'Disconnettersi',
            notifications: {
                failure: 'Non è stato possibile disconnettere il tuo account.',
                success: 'Il tuo account è stato disconnesso con successo',
            },
        },
    },
    components: {
        autocomplete: {
            hinttext: 'Digita per iniziare la ricerca',
        },
    },
    countries: {
        AD: 'Andorra',
        AE: 'Emirati Arabi Uniti',
        AF: 'afghanistan',
        AG: 'Antigua e Barbuda',
        AI: 'Anguilla',
        AL: 'Albania',
        AM: 'Armenia',
        AO: 'angola',
        AQ: 'Antartide',
        AR: 'Argentina',
        AS: 'Samoa americane',
        AT: 'Austria',
        AU: 'Australia',
        AW: 'aruba',
        AX: 'Isole Aland',
        AZ: 'Azerbaijan',
        BA: 'Bosnia Erzegovina',
        BB: 'Barbados',
        BD: 'Bangladesh',
        BE: 'Belgio',
        BF: 'Burkina Faso',
        BG: 'Bulgaria',
        BH: 'Bahrain',
        BI: 'Burundi',
        BJ: 'Benin',
        BL: 'Saint Barthelemy',
        BM: 'Bermuda',
        BN: 'Brunei',
        BO: 'Bolivia',
        BQ: 'Bonaire, Sant’Eustazio e Saba',
        BR: 'Brasile',
        BS: 'Bahamas',
        BT: 'Bhutan',
        BV: 'Isola Bouvet',
        BW: 'Botswana',
        BY: 'Bielorussia',
        BZ: 'Belize',
        CA: 'Canada',
        CC: 'Isole Cocos',
        CD: 'Repubblica Democratica del Congo',
        CF: 'Repubblica Centrafricana',
        CG: 'Repubblica del Congo',
        CH: 'Svizzera',
        CI: 'Costa d’Avorio',
        CK: 'Isole Cook',
        CL: 'Chile',
        CM: 'Camerun',
        CN: 'Cina',
        CO: 'Colombia',
        CR: 'Costa Rica',
        CU: 'Cuba',
        CV: 'capo Verde',
        CW: 'Curacao',
        CX: 'Isola di Natale',
        CY: 'Cipro',
        CZ: 'Repubblica Ceca',
        DE: 'Germania',
        DJ: 'Gibuti',
        DK: 'Danimarca',
        DM: 'Dominica',
        DO: 'Repubblica Dominicana',
        DZ: 'algeria',
        EC: 'Ecuador',
        EE: 'Estonia',
        EG: 'Egitto',
        EH: 'Sahara occidentale',
        ER: 'l’Eritrea',
        ES: 'Spagna',
        ET: 'Etiopia',
        FI: 'Finlandia',
        FJ: 'Fiji',
        FK: 'Isole Falkland',
        FM: 'Micronesia',
        FO: 'Isole Faroe',
        FR: 'Francia',
        GA: 'Gabon',
        GB: 'Regno Unito',
        GD: 'Grenada',
        GE: 'Georgia',
        GF: 'Guiana francese',
        GG: 'maglione',
        GH: 'Ghana',
        GI: 'Gibilterra',
        GL: 'Groenlandia',
        GM: 'Gambia',
        GN: 'Guinea',
        GP: 'Guadeloupe',
        GQ: 'Guinea Equatoriale',
        GR: 'Grecia',
        GS: 'Georgia del Sud e Isole Sandwich Meridionali',
        GT: 'Guatemala',
        GU: 'Guam',
        GW: 'Guinea-Bissau',
        GY: 'Guyana',
        HK: 'Hong Kong',
        HM: 'Heard Island e McDonald Islands',
        HN: 'Honduras',
        HR: 'Croazia',
        HT: 'Haiti',
        HU: 'Ungheria',
        ID: 'Indonesia',
        IE: 'Irlanda',
        IL: 'Israele',
        IM: 'Isola di Man',
        IN: 'India',
        IO: 'Territorio britannico dell’Oceano Indiano',
        IQ: 'Iraq',
        IR: 'Mi sono imbattuto',
        IS: 'Islanda',
        IT: 'Italia',
        JE: 'maglia',
        JM: 'Giamaica',
        JO: 'Giordania',
        JP: 'Giappone',
        KE: 'Kenia',
        KG: 'Kyrgyzstan',
        KH: 'Cambogia',
        KI: 'Kiribati',
        KM: 'Comoros',
        KN: 'Saint Kitts e Nevis',
        KP: 'Corea del nord',
        KR: 'Corea del Sud',
        KW: 'Kuwait',
        KY: 'Isole Cayman',
        KZ: 'Kazakistan',
        LA: 'Laos',
        LB: 'Libano',
        LC: 'Santa Lucia',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Liberia',
        LS: 'Lesoto',
        LT: 'Lituania',
        LU: 'Lussemburgo',
        LV: 'Lettonia',
        LY: 'Libia',
        MA: 'Marocco',
        MC: 'Monaco',
        MD: 'Moldova',
        ME: 'Montenegro',
        MF: 'Saint Martin',
        MG: 'Madagascar',
        MH: 'Isole Marshall',
        MK: 'Macedonia',
        ML: 'Mali',
        MM: 'Myanmar',
        MN: 'Mongolia',
        MO: 'Macao',
        MP: 'Isole Marianne settentrionali',
        MQ: 'Martinique',
        MR: 'Mauritania',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Mauritius',
        MV: 'Maldive',
        MW: 'Malawi',
        MX: 'Messico',
        MY: 'Malaysia',
        MZ: 'Mozambico',
        NA: 'Namibia',
        NC: 'Nuova Caledonia',
        NE: 'Niger',
        NF: 'Isole Norfolk',
        NG: 'Nigeria',
        NI: 'Nicaragua',
        NL: 'Olanda',
        NO: 'Norvegia',
        NP: 'Nepal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'Nuova Zelanda',
        OM: 'Oman',
        PA: 'Panama',
        PE: 'Perù',
        PF: 'Polinesia francese',
        PG: 'Papua Nuova Guinea',
        PH: 'Filippine',
        PK: 'Pakistan',
        PL: 'Polonia',
        PM: 'Saint Pierre e Miquelon',
        PN: 'Pitcairn',
        PR: 'Puerto Rico',
        PS: 'Territorio palestinese',
        PT: 'Portogallo',
        PW: 'Palau',
        PY: 'Paraguay',
        QA: 'Qatar',
        RE: 'Riunione',
        RO: 'Romania',
        RS: 'Serbia',
        RU: 'Russia',
        RW: 'Ruanda',
        SA: 'Arabia Saudita',
        SB: 'Isole Salomone',
        SC: 'Seychelles',
        SD: 'Sudan',
        SE: 'Svezia',
        SG: 'Singapore',
        SH: 'Sant’Elena',
        SI: 'Slovenia',
        SJ: 'Svalbard e Jan Mayen',
        SK: 'Slovacchia',
        SL: 'Sierra Leone',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somalia',
        SR: 'Suriname',
        SS: 'Sudan del Sud',
        ST: 'Sao Tome e Principe',
        SV: 'El Salvador',
        SX: 'Sint Maarten',
        SY: 'Siria',
        SZ: 'Swaziland',
        TC: 'Isole Turks e Caicos',
        TD: 'Chad',
        TF: 'Territori della Francia del sud',
        TG: 'Andare',
        TH: 'Tailandia',
        TJ: 'Tajikistan',
        TK: 'Tokelau',
        TL: 'Timor Est',
        TM: 'Turkmenistan',
        TN: 'Tunisia',
        TO: 'tonga',
        TR: 'tacchino',
        TT: 'Trinidad e Tobago',
        TV: 'Tuvalu',
        TW: 'Taiwan',
        TZ: 'Tanzania',
        UA: 'Ucraina',
        UG: 'Uganda',
        UM: 'Isole minori esterne degli Stati Uniti',
        US: 'stati Uniti',
        UY: 'Uruguay',
        UZ: 'Uzbekistan',
        VA: 'Vaticano',
        VC: 'Saint Vincent e Grenadine',
        VE: 'Venezuela',
        VG: 'Isole Vergini Britanniche',
        VI: 'Isole Vergini americane',
        VN: 'Vietnam',
        VU: 'Vanuatu',
        WF: 'Wallis e Futuna',
        WS: 'Samoa',
        XK: 'Kosovo',
        YE: 'yemen',
        YT: 'Mayotte',
        ZA: 'Sud Africa',
        ZM: 'Zambia',
        ZW: 'Zimbabwe',
    },
    elements: {
        confirm: {
            description: 'Non potrai modificare i prodotti dell’abbonamento dopo questa azione.',
            title: 'Sei sicuro di voler confermare questo abbonamento?',
        },
        delete: {
            description: 'L’oggetto sarà rimosso in modo permanente. Questa azione non può essere annullata.',
            title: 'Sei sicuro di voler cancellare questo?',
        },
        outdatedBrowser: {
            description: 'Il nostro strumento Dashboard non supporta la versione corrente del tuo browser. Per un’esperienza migliore sull’utilizzo di questo sito Web, aggiornare il browser all’ultima versione.',
            linkText: 'Clicca qui per scoprire come',
            title: 'Migliora la tua esperienza su Dashboard!',
        },
        terminate: {
            description: 'L’abbonamento sarà terminato definitivamente.',
            title: 'Sei sicuro di voler interrompere questo abbonamento?',
        },
    },
    export: {
        error: {
            maximum_reached: 'Ma le nostre esportazioni non possono contenere più di 15.000 prenotazioni. È possibile aggiungere più filtri per ridurre il numero di prenotazioni o continuare ed esportare i primi 15.000 risultati.',
            title: 'Sapevamo che hai successo...',
        },
        description: 'Seleziona quali campi desideri visualizzare nell’esportazione',
        notifications: {
            empty_filters: {
                description: 'Ciò richiede uno o più filtri applicati. Applica uno o più filtri per effettuare un’esportazione.',
                title: 'Mancano dei filtri',
            },
        },
        title: 'Preparare l’esportazione',
        field_groups: {
            booking: 'Dettagli della prenotazione',
            consumer: 'Consumatore',
            customer: 'Dettagli cliente',
            default: 'Predefinito',
            financial: 'Dettagli finanziari',
            payment_method: 'Metodo di pagamento',
            product: 'Prodotto',
            user_attributes: 'Attributi utente',
        },
        fields: {
            administration_fee: 'Tariffa di amministrazione',
            amount: 'Importo',
            arrival_date: 'Data d’arrivo',
            booking_date: 'Data di prenotazione',
            costfree_cancellation: 'Assicurazione annullamento',
            currency: 'Moneta',
            customer_email: 'Email del cliente',
            customer_first_name: 'Nome del cliente',
            customer_last_name: 'Cognome del cliente',
            customer_license_plate: 'Targa del cliente',
            customer_phone: 'Telefono del cliente',
            customer_remarks: 'Commenti dei clienti',
            departure_date: 'Data di partenza',
            discount_amount: 'Totale sconto',
            discount_company_name: 'Nome della società di sconto',
            discount_owner_id: 'ID proprietario sconto',
            discount_title: 'Nome sconto',
            email: 'E-mail',
            first_name: 'Nome di battesimo',
            gateway: 'Portale',
            has_failed_invoice: 'Ha una fattura non riuscita',
            id: 'ID',
            internal_order_id: 'ID ordine',
            invoiced_at: 'Fatturato a',
            last_name: 'Cognome',
            locale: 'Lingua',
            method: 'Metodo',
            number_of_persons: 'Numero di persone',
            options_price: 'Prezzo delle opzioni',
            order_id: 'ID ordine',
            payment_amount_paid: 'Importo del pagamento pagato',
            payment_method: 'Payment method',
            payment_method_status: 'Payment method status',
            price_membership_deduction: 'Membership deduction',
            payment_status: 'Stato del pagamento',
            phone: 'Numero di telefono',
            price: 'Prezzo',
            product_address: 'Indirizzo del prodotto',
            product_id: 'Numero identificativo del prodotto',
            product: 'Prodotto',
            provider_id: 'ID provider',
            provider_price_total: 'Prezzo totale fornitore',
            provider_price: 'Prezzo del fornitore',
            provider: 'Provider',
            reseller_funnel: 'Imbuto rivenditore',
            reseller_id: 'ID rivenditore',
            reseller_price_total: 'Prezzo del rivenditore totale',
            reseller_price: 'Prezzo rivenditore',
            reseller: 'Reseller',
            reservation_status: 'Stato della prenotazione',
            return_flight_number: 'Numero del volo di ritorno',
            status: 'Stato',
            transaction_fee: 'Costo della transazione',
            yield_price: 'Prezzo di rendimento',
        },
    },
    fields: {
        currency: 'Valuta',
        dates: 'Data',
        datetime: {
            never: 'Mai',
        },
        empty: 'Sconosciuto',
        ends_at: 'Finisce a',
        full: 'Completo',
        is_scheduled: 'Programmato',
        none: 'Nessuno',
        optional: '(Opzionale)',
        other: 'Altro',
        percentage: 'Percentuale',
        price: 'Prezzo',
        price_original: 'Prezzo originale',
        reason: 'Motivo',
        size: 'Dimensione',
        starts_at: 'Inizia a',
        updated: 'Aggiornato',
        weekday: {
            1: 'Lunedi',
            2: 'Martedì',
            3: 'Mercoledì',
            4: 'Giovedi',
            5: 'Venerdì',
            6: 'Sabato',
            7: 'Domenica',
        },
    },
    forms: {
        email: 'Deve essere un’e-mail',
        error: {
            'location-not-found': 'Impossibile trovare la posizione',
            'location-could-not-be-resolved': 'Impossibile trovare la posizione',
            'the-id-format-is-invalid': 'Il formato dell’ID non è valido',
        },
        invalid: {
            discount_rule: 'Regola di sconto non valida',
            email: 'E-mail non valido',
            first_name: 'Nome non valido',
            general: 'Caratteri non validi',
            last_name: 'Cognome non valido',
            match: 'The value with %{field} does not match',
            max_characters: 'Deve contenere %{max} caratteri o meno',
            phone: 'Questo è un numero di telefono non valido',
            url: 'Questo è un URL non valido',
        },
        localisation: {
            available: {
                title: 'Aggiungi una lingua',
            },
            origin: {
                description: 'Desideri tradurre gli attuali testi %{locale} in %{target}?',
                title: 'tradurre in %{source}',
            },
            update: {
                description: ' Desideri tradurre gli attuali testi %{locale} in %{target}?',
                description_2: 'La traduzione sovrascriverà gli attuali testi %{target}.',
                description_3: 'Non vengono salvati fino a quando non si invia il modulo.',
                inactive: 'Aggiungi il testo in %{locale} prima di poter tradurre in questa lingua.',
                title: 'Traduci dall’inglese',
            },
            required: {
                description: 'È obbligatorio inserire tutti i testi in inglese prima di poter aggiungere altre lingue.',
                title: 'Aggiungi una lingua',
            },
        },
        no_results: 'Non ci sono descrizioni aggiunte a questo prodotto.',
        number: 'Deve essere un numero',
        one_of_them_required: 'Compilare uno di questi campi.',
        required: 'Necessario',
        submit: {
            required: '%{locale} - %{key} è obbligatorio',
        },
    },
    filters: {
        add: 'Aggiungi un filtro',
        category: {
            advanced: 'Avanzate',
            basic: 'di base',
        },
        clear_all_filters: 'Cancella tutti i filtri',
        components: {
            accountId: {
                label: 'Account',
            },
            booking: {
                label: 'Prenotazione',
            },
            bookingOrderId: {
                label: 'Id dell’ordine di prenotazione',
            },
            bookingReservationOrderId: {
                label: 'ID ordine di prenotazione',
            },
            cancelled: {
                label: 'Annullata',
            },
            cancelledAt: {
                label: 'Annullato alle',
                placeholder: 'Scegli una data',
            },
            categoryId: {
                label: 'Categoria',
                placeholder: 'Scegli una categoria',
            },
            companyName: {
                label: 'Nome dell’azienda',
            },
            createdAt: {
                label: 'Creato a',
                placeholder: 'Scegli una data',
            },
            currencies: {
                label: 'Valute',
                placeholder: 'Scegli una valuta',
            },
            email: {
                label: 'E-mail',
            },
            enabled: {
                choices: {
                    active: 'Solo attivo',
                    inactive: 'Solo inattivo',
                },
                label: 'Abilitato',
            },
            end_date_null_or_from: {
                label: 'Termina da',
            },
            funnelId: {
                label: 'Campagne',
            },
            interval: {
                choices: {
                    date: 'data',
                    day: 'giorno',
                    month: 'mese',
                    week: 'Settimana',
                    year: 'anno',
                },
                label: 'Intervallo',
            },
            invoice: {
                label: 'Fattura',
            },
            is_rebooked: {
                choices: {
                    active: 'Solo riprenotati',
                    inactive: 'Solo non riprenotati',
                },
                label: 'Riprenotato',
            },
            is_terminated: {
                label: 'Terminato',
            },
            lastName: {
                label: 'Cognome',
            },
            licensePlate: {
                label: 'Targa',
            },
            name: {
                label: 'Nome',
            },
            orderId: {
                label: 'ID ordine',
            },
            paymentStatus: {
                choices: {
                    chargedback: 'Ricaricato',
                    deferred: 'Differite',
                    failed: 'Mancato',
                    inProgress: 'In corso',
                    refunded: 'Rimborsato',
                    success: 'Successo',
                    unknown: 'Sconosciuto',
                },
                label: 'Stato del pagamento',
                placeholder: 'Seleziona il tuo pagamento',
            },
            phone: {
                label: 'Numero di telefono',
            },
            pointOfInterestId: {
                label: 'Punto d’interesse',
            },
            productId: {
                label: 'Prodotto',
            },
            providerId: {
                label: 'Provider',
            },
            resellerId: {
                label: 'Rivenditore',
            },
            reservationStatus: {
                choices: {
                    awaiting: 'In attesa di',
                    canceled: 'Annullato',
                    completed: 'Completato',
                    error: 'Errore',
                    pending: 'In attesa di',
                    split: 'Diviso',
                    underReview: 'In fase di revisione',
                },
                label: 'Stato della prenotazione',
            },
            subcategoryId: {
                label: 'Sottocategoria',
                placeholder: 'Sottocategoria',
            },
            status: {
                label: 'Stato',
            },
            testBooking: {
                choices: {
                    real: 'Solo reale',
                    test: 'Solo test',
                },
                label: 'Tipo di prenotazione',
            },
            userId: {
                label: 'Utente',
            },
            product_membership_id: {
                label: 'Iscrizione al prodotto',
            },
            user_product_membership_pool_id: {
                label: 'Pool di iscrizione al prodotto',
            },
            usesDiscountCodes: {
                choices: {
                    active: 'Usa i codici sconto',
                    inactive: 'Nessun codice sconto',
                },
                label: 'Utilizza i codici sconto',
            },
        },
        title: 'filtri',
        matchtype: 'Tipo di corrispondenza',
        matchtypes: {
            between: 'Fra',
            contains: 'contiene',
            ends_with: 'Finisce con',
            equals: 'È uguale a',
            match_all_of: 'Abbina tutto',
            match_one_of: 'Abbina uno di',
            near: 'Vicino',
            range: 'Entro',
            starts_with: 'Inizia con',
        },
    },
    general: {
        data_updated: 'Dati aggiornati',
        error: 'Qualcosa è andato storto, per favore riprova più tardi ...',
        images: 'Immagini',
        loading: 'Caricamento in corso...',
        noMatches: 'Impossibile trovare nessuna corrispondenza',
    },
    impersonation: {
        actions: {
            log_in: 'Impersonare',
            log_out: 'Torna al tuo account',
        },
        logged_in: 'Sei attualmente connesso come %{name}',
    },
    languages: {
        dutch: 'Olandese',
        english: 'Inglese',
        german: 'Tedesco',
        french: 'Francese',
        italian: 'Italiano',
        spanish: 'Spagnolo',
    },
    localisations: {
        dialog: {
            label: 'Seleziona una lingua disponibile',
        },
    },
    dropzone: {
        label: {
            button: 'Carica il logo',
            button_image: 'Carica immagine',
            description_file_max: 'Dimensione massima del file: %{max} KB',
            description_max: 'Altezza massima: %{height}px, Larghezza massima: %{width}px',
            description_min: 'Altezza minima: %{height}px, Larghezza minima: %{width}px',
            format: 'Formato: %{format}',
            highlight_image: 'Evidenzia l’immagine',
            highlighted_image: 'Immagine evidenziata',
            remove_highlight: 'Rimuovere l’evidenziazione',
            text: 'Fai clic o trascina un’immagine',
        },
    },
    menu: {
        sidebar: {
            assets: 'Assets',
            access_points: 'Punti di accesso',
            accounts: 'Conti',
            account_administration: 'Amministrazione dell’account',
            account_details: 'Dettagli account',
            account_yields: 'cedimento',
            all_users: 'Tutti gli utenti',
            'api-keys': 'API keys',
            bookingStats: 'Statistica',
            bookings: 'Prenotazioni',
            campaigns: 'Campagne',
            content: 'Contenuto',
            dashboard: 'Dashboard',
            discounts: 'Sconti',
            internal_yield_service_user: 'Rendimenti',
            invoices: 'Fatture',
            legaldocuments: {
                engagement_agreement: 'Accordo di fidanzamento',
                main: 'Documenti legali',
                privacy_statement: 'Informativa sulla Privacy',
                terms_conditions: 'Termini e condizioni',
            },
            memberships: 'Appartenenze',
            membership_schedules: 'Piani di abbonamento',
            membership_pools: 'Pool di adesione',
            order_create: 'Crea una prenotazione',
            order_create_disallowed: 'Il tuo account è inattivo. Contatta MOBIAN per riattivare.',
            points_of_interest: 'Points of interest',
            products: 'Prodotti',
            product_memberships: 'Adesioni ai prodotti',
            properties: 'Proprietà',
            propertygroups: 'Property groups',
            reservations: 'Prenotazioni',
            settings: 'Impostazioni',
            subcategories: 'Subcategories',
            subscriptions: 'Abbonamenti',
            system_administration: 'Amministrazione di sistema',
            users: 'Utenti',
            webhooks: 'Webhooks',
        },
        topbar: {
            accounts: {
                current: 'Attuale',
                modal_title: 'Seleziona un account',
                no_account_selected: 'Nessun account selezionato',
            },
            security: 'Security',
            profile: 'Profilo',
            stop_impersonation: 'Smetti di imitare',
        },
    },
    notifications: {
        access_methods: {
            create: {
                success: 'Il metodo di accesso è stato aggiunto con successo',
            },
            delete: {
                success: 'Il metodo di accesso è stato eliminato con successo',
            },
            open: {
                success: 'Il cancello è stato aperto',
            },
            update: {
                success: 'Il metodo di accesso è stato aggiornato con successo',
            },
        },
        account_yields: {
            create: {
                success: 'Il rendimento dell’utente è stato aggiunto correttamente',
            },
            delete: {
                success: 'Il rendimento dell’utente è stato rimosso con successo',
            },
            update: {
                success: 'Il rendimento dell’utente è stato modificato correttamente',
            },
        },
        accounts: {
            create: {
                success: 'L’account è stato aggiunto correttamente',
                search_user_limit: 'Vengono mostrati solo i primi %{count} risultati, perfezionare ulteriormente i criteri di ricerca.',
            },
            update: {
                success: 'L’account è stato modificato correttamente',
            },
        },
        'api-keys': {
            create: {
                success: 'Il API chiave è stato aggiunto con successo',
            },
            delete: {
                success: 'Il API chiave è stato rimosso con successo',
            },
            update: {
                success: 'Il API chiave è cambiato con successo.',
            },
        },
        bookings: {
            amend: {
                failure: 'La prenotazione non è stata modificata',
                success: 'La prenotazione è stata modificata con successo',
            },
            refund: {
                failure: 'Il rimborso non è andato a buon fine',
                success: 'Il rimborso è avvenuto con successo',
            },
        },
        booking: {
            cancelled: 'La prenotazione è stata cancellata con successo',
        },
        export: {
            failure: 'L’esportazione non può essere inviata',
            orders: {
                failure: 'L’esportazione non può essere inviata',
                success: 'L’esportazione viene inviata quando è pronta',
            },
            success: 'L’esportazione viene inviata quando è pronta',
        },
        campaigns: {
            create: {
                success: 'La campagna è stata aggiunta',
            },
            update: {
                success: 'La campagna è stata aggiornata',
            },
            remove: {
                success: 'La campagna è stata rimossa',
            },
        },
        current_account: {
            delete: {
                success: 'L’utente è stato rimosso da questo account',
            },
        },
        discounts: {
            create: {
                success: 'Lo sconto è stato aggiunto correttamente',
            },
            delete: {
                success: 'Lo sconto è stato rimosso correttamente',
            },
            update: {
                success: 'Lo sconto è stato modificato correttamente',
            },
        },
        discount_codes: {
            create: {
                success: 'Il codice sconto è stato aggiunto correttamente',
            },
            delete: {
                success: 'Il codice sconto è stato rimosso correttamente',
            },
            update: {
                success: 'Il codice sconto è stato modificato correttamente',
            },
        },
        invitations: {
            created: 'L’invito è stato aggiunto con successo',
            deleted: 'L’invito è stato rimosso con successo',
            accepted: 'L’invito è stato accettato',
            denied: 'L’invito è stato negato',
        },
        item: {
            created: 'L’articolo è stato aggiunto con successo',
            updated: 'Il prodotto è stato cambiato correttamente',
        },
        memberships: {
            added: 'L’utente è stato aggiunto all’abbonamento con successo',
            delete: {
                success: 'L’utente è stato rimosso dall’iscrizione',
            },
        },
        orders: {
            cancelled: {
                success: 'Order cancelled',
            },
            retry: {
                success: 'La prenotazione è stata riprenotata',
            },
            suspicious: 'Suspicious activity on this booking',
            update: {
                success: 'La prenotazione è cambiata con successo',
            },
        },
        points_of_interest: {
            create: {
                success: 'Il POI è stato aggiunto con successo',
            },
            delete: {
                success: 'Il POI è stato rimosso con successo',
            },
            images: {
                create: {
                    success: 'L’immagine è stata aggiunta con successo',
                },
                delete: {
                    success: 'L’immagine è stata rimossa con successo',
                },
            },
            import: {
                success: 'I POI sono stati aggiunti con successo',
            },
            update: {
                success: 'Il POI è cambiato con successo',
            },
        },
        product_options: {
            failure: 'Opzione del prodotto non rimossa',
            success: 'Opzione di prodotto rimossa',
        },
        products: {
            create: {
                success: 'Il prodotto è stato aggiunto con successo',
            },
            configuration: {
                administration_fee: {
                    maximum: 'Massimo',
                    maximum_placeholder: 'ad es. 1.99, 2.50',
                    minimum: 'Minimo',
                    minimum_placeholder: 'ad es. 1.99, 2.50',
                    percentage: 'Percentuale',
                    percentage_placeholder: 'ad es. 0.10 (10%), 0.03 (3%)',
                },
                allow_exceed_capacity_from: 'Capacità consentita superata non valida',
                allow_overstay: 'Sforamento consentito non valido',
                arrival_dates_blocked: 'Date di arrivo bloccate non valide',
                blocked_dates: 'Date bloccate non valide',
                capacity: 'Capacità non valida',
                departure_dates_blocked: 'Date di partenza bloccate non valide',
                freeze_period: 'Periodo di congelamento non valido',
                leeway_arrival: 'Margine di tempo di arrivo non valido',
                leeway_departure: 'Margine di tempo di partenza non valido',
                maximum_advance: 'Tempo massimo anticipato non valido',
                maximum_duration: 'Tempo minimo anticipato non valido',
                minimum_advance: 'Tempo minimo anticipato non valido',
                minimum_duration: 'Durata non valida',
                number_of_persons: 'Numero di persone non valido',
                operational_times: 'Sono consentiti orari operativi non validi, specifici o non specifici solo per i giorni feriali',
                sales_price: 'Prezzo di vendita non valido',
                split_percentage: 'Percentuale di prezzo suddiviso non valida',
                terms_and_conditions: {
                    name: 'Nome non valido',
                    link: 'URL non valida',
                },
                vat_percentage: 'Percentuale di IVA non valida',
                voucher_include_invoice: 'Il voucher include la fattura non valida',
            },
            delete: {
                success: 'Il prodotto è stato rimosso con successo',
            },
            update: {
                success: 'Il prodotto è cambiato con successo',
            },
            failure: 'Prodotto non rimossa',
            images: {
                create: {
                    success: 'L’immagine è stata aggiunta con successo',
                },
                delete: {
                    success: 'L’immagine è stata rimossa con successo',
                },
            },
            localisation: {
                update: {
                    success: 'I testi sono stati aggiornati con successo',
                },
            },
            logo: {
                create: {
                    failure: 'Si è verificato un errore durante il caricamento del logo',
                    success: 'Il logo è stato caricato',
                },
                delete: {
                    failure: 'Si è verificato un errore durante l’eliminazione del logo',
                    success: 'Il logo è cancellato',
                },
            },
            property: {
                create: {
                    success: 'La proprietà è stata aggiunta con successo',
                },
                update: {
                    success: 'La proprietà è cambiata con successo',
                },
                delete: {
                    success: 'La proprietà è stata rimossa con successo',
                },
            },
            related: {
                create: {
                    success: 'Il prodotto è stato assegnato',
                },
                delete: {
                    success: 'La relazione tra i prodotti è eliminata',
                },
            },
            resource: {
                available_resources: {
                    failure: 'Qualcosa è andato storto durante il recupero delle risorse disponibili',
                },
                update: {
                    success: 'La risorsa del prodotto è stata modificata con successo',
                },
            },
        },
        propertygroups: {
            create: {
                success: 'Il gruppo di proprietà è stato aggiunto con successo',
            },
            delete: {
                success: 'Il gruppo di proprietà è stato rimosso con successo',
            },
            update: {
                success: 'Il gruppo di proprietà è cambiata con successo',
            },
        },
        profile: {
            update: {
                success: 'Il profilo è stato modificato con successo.',
            },
        },
        properties: {
            create: {
                success: 'Le proprietà sono state aggiunte con successo',
            },
            delete: {
                success: 'Le proprietà sono state rimosse con successo',
            },
            update: {
                success: 'Le proprietà sono cambiate con successo',
            },
        },
        subcategories: {
            create: {
                success: 'La sottocategoria è stata aggiunta con successo',
            },
            update: {
                success: 'La sottocategoria è stata cambiata con successo',
            },
            delete: {
                success: 'La sottocategoria è stata rimossa con successo',
            },
        },
        subscriptions: {
            create: {
                success: 'L’abbonamento è stato aggiunto con successo',
            },
            delete: {
                success: 'L’abbonamento è stato rimosso con successo',
            },
            update: {
                success: 'L’abbonamento è cambiato con successo',
            },
            confirm: {
                success: 'L’abbonamento è stato confermato con successo',
            },
            terminate: {
                success: 'L’abbonamento è stato terminato con successo',
            },
        },
        subscriptionProducts: {
            create: {
                success: 'Il prodotto di abbonamento è stato aggiunto con successo',
            },
            delete: {
                success: 'Il prodotto di abbonamento è stato rimosso con successo',
            },
        },
        users: {
            create: {
                success: 'L’utente è stato aggiunto con successo',
            },
            delete: {
                success: 'L’utente è stato rimosso con successo',
            },
            update: {
                success: 'L’utente è stato modificato con successo',
            },
            confirmed: {
                success: 'L’utente è stato confermato con successo',
            },
            password: {
                failure: 'Si è verificato un errore durante l’invio della richiesta. Riprovare più tardi.',
                success: 'L’utente verrà informato via e-mail con una richiesta di reimpostazione della password.',
            },
        },
        user_product_membership: {
            create: {
                success: 'L’iscrizione al prodotto dell’utente è stata aggiunta',
            },
            delete: {
                success: 'L’iscrizione al prodotto dell’utente è stata rimossa',
            },
            update: {
                success: 'L’iscrizione al prodotto dell’utente è stata aggiornata',
            },
        },
        utilities: {
            translate: {
                create: {
                    success: 'Il testo di base è stato tradotto.',
                },
            },
        },
        yields: {
            delete: {
                success: 'Il rendimento è stato rimosso con successo',
            },
        },
        webhooks: {
            create: {
                success: 'Il webhook è stato aggiunto con successo',
            },
            update: {
                success: 'Il webhook è stato aggiornato con successo',
            },
            delete: {
                success: 'Il webhook è stato rimosso con successo',
            },
        },
    },
    pages: {
        booking_tool: {
            not_available: {
                text: 'Sembra che Dashboard Campagna non sia disponibile per questo account. Per maggiori informazioni, contatta il tuo account manager.',
                title: 'Oh no... :(',
            },
        },
        create_booking: {
            description: 'Prima di poter vedere i prodotti, ti chiediamo di compilare questi campi, per rendere la ricerca più specifica.',
            form: {
                errors: {
                    destination_arrival_date: 'Si prega di inserire una data',
                    destination_arrival_time: 'Si prega di compilare un tempo',
                    destination_departure_date: 'Si prega di inserire una data',
                    destination_departure_time: 'Si prega di compilare un tempo',
                    destination_google_place_id: 'Si prega di compilare una destinazione',
                    number_of_persons: 'Si prega di compilare la quantità di persone',
                    one_way: 'Si prega di compilare il tipo di viaggio',
                    origin_google_place_id: 'Si prega di compilare l’indirizzo per essere ritirati',
                },
                fields: {
                    destination_arrival_date: 'Quando vuoi partire?',
                    destination_arrival_time: 'Orario di partenza',
                    destination_departure_date: 'Quando vuoi tornare?',
                    destination_departure_time: 'Tempo di ritorno',
                    destination_google_place_id: 'Qual è la sua destinazione?',
                    one_way: {
                        retour_trip: 'Retour viaggio',
                        single_trip: 'Viaggio singolo',
                    },
                    origin_google_place_id: 'Il mio indirizzo',
                    service: {
                        park_and_sleep: 'Parcheggia e dormi',
                        park_and_walk: 'Parcheggia e cammini',
                        public_transport: 'Trasporto pubblico',
                        short_long_parking: 'Parcheggio a breve / lungo termine',
                        taxi: 'Taxi',
                        title: 'Opzioni di servizio',
                        valet_parking: 'Valet Parking',
                    },
                },
            },
            not_available: {
                text: 'Sembra che Dashboard Funnel non sia disponibile per questo account. Per maggiori informazioni, contatta il tuo account manager.',
                title: 'Oh no... :(',
            },
            title: 'Crea una prenotazione',
        },
        dashboard: {
            select: 'Seleziona la tua valuta',
            widgets: {
                statistics_card: {
                    bookings: 'Prenotazioni',
                    current_week: 'Questa settimana',
                    last_week: 'La settimana scorsa',
                    today: 'Oggi',
                    week: 'Settimana',
                    yesterday: 'Ieri',
                },
                statistics_graph: {
                    current_month: 'Ultime 4 settimane',
                    previous_year: 'L’anno scorso',
                    title: 'Prenotazioni',
                },
            },
        },
    },
    resources: {
        access_methods: {
            create: {
                title: 'Creare un metodo di accesso',
            },
            delete: {
                title: 'Elimina metodo di accesso',
                description: 'Sei sicuro di voler eliminare questo metodo di accesso?',
            },
            edit: {
                title: 'Modifica questo metodo di accesso',
            },
            fields: {
                access_id: 'ID di accesso',
                access_point_access_method_id: 'ID del metodo di accesso del punto di accesso',
                access_point_id: 'ID punto di accesso',
                carpark_id: 'ID parcheggio',
                connector_id: 'ID del connettore',
                custom_counter_id: 'ID contatore personalizzato',
                depot_id: 'ID Deposito',
                direction: 'Direzione',
                door_id: 'ID porta',
                enabled: 'Stato',
                gate_id: 'ID gate',
                is_allowed_for_users: 'Permetti agli utenti',
                location_id: 'ID della posizione',
                name: 'Nome',
                phone: 'Numero di telefono',
                phone_country: 'Paese del numero di telefono',
                product_id: 'Numero identificativo del prodotto',
                station_id: 'ID stazione',
                subscription_id: 'ID dell’abbonamento',
            },
            list: {
                active: 'Attivo',
                direction: 'Direzione',
                directions: {
                    1: 'Entra / Esci',
                    2: 'Accedere',
                    3: 'Uscita',
                },
                enabled: 'Stato',
                inactive: 'Inattivo',
            },
            no_results: 'Nessun metodo di accesso trovato',
            open: 'Cancello aperto',
            requesting: 'Richiesta',
            title: 'Metodo di accesso',
        },
        access_points: {
            actions: {
                create: {
                    title: 'Creare un punto di accesso',
                },
                edit: {
                    title: 'Modifica questo punto di accesso: %{title}',
                },
            },
            fields: {
                access_point: 'Scegliere un punto di accesso',
                access_method: 'Scegliere un metodo di accesso',
                product: 'Prodotto',
                title: 'Titolo',
                type: 'Tipo',
            },
            no_results: 'Nessun punto di accesso trovato',
            title: 'Punti di accesso',
            types: {
                access: 'Accesso',
                on_site: 'Sul sito',
            },
        },
        account_yields: {
            actions: {
                create: 'Crea un rendimento utente',
                edit: 'Aggiorna rendimento utente',
            },
            fields: {
                accountId: 'Utente',
                yield: 'Yield',
            },
            title: 'Yields',
        },
        accounts: {
            actions: {
                activate: 'Attivare',
                create: 'Crea un conto',
                deactivate: 'Disattiva',
                edit: 'Modifica conto',
            },
            activity: {
                activate: {
                    title: 'Il conto verrà attivato',
                    description: 'Quando il conto è attivo, il conto può accedere ai nostri dashboard, app e utilizzare i nostri servizi.',
                },
                deactivate: {
                    title: 'Il conto verrà disattivato',
                    description: 'Quando il conto è inattivo, il conto non può più accedere ai nostri dashboard, app o utilizzare i nostri servizi.',
                },
            },
            fields: {
                address: 'Indirizzo',
                bic: 'BIC',
                city: 'Città',
                contact_details: 'Dettagli di contatto',
                contact_email: 'Email',
                contact_emergency_phone: 'Telefono di emergenza',
                contact_phone: 'Telefono di contatto',
                contact_whatsapp: 'Numero Whatsapp',
                country: 'Nazione',
                email: 'E-mail',
                iban: 'IBAN',
                is_enabled: 'Attivo',
                last_name: 'Cognome',
                locale: 'Locale',
                name: 'Nome',
                notify_on_cancelled: 'Melden bij annulering',
                notify_on_created: 'Melden bij aangemaakt',
                notify_on_modified: 'Melden op gewijzigd',
                orders: 'Ordini',
                owner: 'Proprietario',
                phone: 'Telefono',
                registration: 'Numero COC',
                role: 'Ruolo',
                vat: 'IVA',
                zipcode: 'Cap',
            },
            filters: {
                active: {
                    active: 'Solo attivo',
                    inactive: 'Solo inattivo',
                },
            },
            forms: {
                account: 'Account',
                account_search_user: 'Cerca utente',
                account_select_user: 'Seleziona utente',
                address: 'Indirizzo',
                company: 'Azienda',
                contact: 'Contatto',
                general: 'Generale',
                notifications: 'Voorkeuren voor e-mailmeldingen',
                products: 'Prodotti attivi aggiornati per ultimi',
                registrations: 'Iscrizioni',
            },
            name: 'Utente',
            notifications: {
                inactive: 'Questo utente è inattivo. Fare clic sul pulsante di attivazione per riattivare l’utente.',
                not_confirmed: 'Questo utente non ha ancora confermato il proprio account.',
            },
            products: {
                actions: {
                    list: 'Mostra tutti i prodotti (%{total})',
                },
            },
            reset_password: {
                description: 'La reimpostazione di una password invierà una nuova password all’e-mail dell’utente. La vecchia password non sarà più utilizzabile. Le sessioni attualmente registrate di questo utente richiederanno loro di accedere su tutti i dispositivi con la loro nuova password.',
                title: 'Reimposta la password dell’utente',
            },
            roles: {
                administrator: 'Amministratore',
                provider: 'Provider',
                reseller: 'Rivenditore',
            },
            select_user: {
                table: {
                    email: 'E-mail',
                    name: 'Nome',
                },
            },
            title: 'Utenti',
        },
        'api-keys': {
            actions: {
                create: 'Crea una API key',
                edit: 'Modifica chiave API Key',
            },
            error: {
                description: 'È stato raggiunto il numero massimo di chiavi API disponibili. Non è possibile creare altre chiavi API. Rimuovine uno prima di crearne uno nuovo.',
                title: 'Ops ...',
            },
            fields: {
                created_at: 'Creato a',
                last_used_at: 'Ultimo uso',
                name: 'Nome',
                token: 'Chiave',
            },
            modal: {
                description: 'Ecco la tua nuova API key. <strong>Questa è l’unica volta in cui il token verrà mai visualizzato, quindi assicurati di non perderlo!</strong> Puoi eliminare il token in qualsiasi momento.',
                title: 'API key per %{name}',
            },
            title: 'API key',
        },
        bookings: {
            actions: {
                edit: 'Prenotazione: %{name} (%{id})',
            },
            amend: {
                buttons: {
                    paymentInvoice: 'Paga tramite fattura',
                    paymentMethod: 'Scegli il metodo di pagamento',
                    price: 'Nuovo prezzo',
                },
                loading: {
                    'price-check-error': 'Qualcosa è andato storto durante la ricerca di un nuovo prezzo',
                    'payment-invoice': 'Tentativo di pagamento tramite fattura',
                    'payment-link': 'Creazione del collegamento di pagamento',
                    'payment-not-required': 'Modifica dei valori aggiornati',
                    form: 'Recupero di nuovi prezzi',
                    payments: 'Recupero di tutti i metodi di pagamento',
                    transactions: 'Creazione di una transazione',
                },
                messages: {
                    'amendError': 'Qualcosa è andato storto durante il salvataggio del modulo.',
                    'payment-invoice': 'Il pagamento è fatturabile. Puoi salvare il modulo.',
                    'payment-not-required': 'Non è richiesto il pagamento. Puoi salvare il modulo.',
                    'payment-required': 'La differenza di prezzo non include i potenziali costi di transazione.',
                    'price-check-error': 'Qualcosa è andato storto durante la ricerca di un nuovo prezzo',
                    availability: 'Questo prodotto non è più disponibile.',
                    linkCopied: 'Il collegamento al pagamento viene copiato',
                },
                prices: {
                    current: 'Prezzo attuale',
                    difference: 'Differenza',
                    new: 'Nuovo prezzo',
                },
                phase: {
                    paymentLink: 'Il tuo link di pagamento per %{title} - %{method}',
                },
                title: 'Modifica la prenotazione',
            },
            fields: {
                createdAt: 'Creato a',
                customerRemarks: 'Osservazioni del cliente',
                destinationArrivalDate: 'Data d’arrivo',
                email: 'E-mail',
                firstName: 'Nome di battesimo',
                fullName: 'Nome e cognome',
                funnelId: 'Campagna',
                lastName: 'Cognome',
                licensePlate: 'Targa',
                locale: 'Locale',
                orderId: 'ID ordine',
                phone: 'Telefono',
                price: 'Prezzo',
                product: 'Prodotto',
                resellerId: 'Rivenditore',
                status: 'Stato',
            },
            forms: {
                additional: 'Aggiuntivo',
                general: 'Generale',
            },
            refund: 'Prenotazione con rimborso',
            title: 'Prenotazioni',
        },
        campaigns: {
            actions: {
                create: 'Crea una campagna',
                edit: 'Aggiorna questa campagna: %{title}',
            },
            fields: {
                accountId: 'Rivenditore',
                id: 'ID',
                identifier: 'identificatore',
                name: 'Nome',
            },
            name: 'Campagna',
            title: 'Campagne',
            show: {
                api: 'API',
                catalogue: 'Catalogare',
                week: 'Settimana',
                last_week: 'Prenotazioni nelle ultime settimane',
                week_number: '# della settimana',
                bookings_amount: '# di prenotazioni',
                tabs_title: 'Informazioni sull’utilizzo del catalogo/API',
                catalogue_p1: 'Non sei pronto per una completa integrazione API ma vuoi iniziare veloce e sicuro? L’imbuto di prenotazione di MOBIAN può essere facilmente utilizzato e funziona immediatamente dopo aver creato una campagna. L’unica cosa che dobbiamo inviare nel tuo link è l’identificatore della tua campagna. Il tuo identificatore è un token univoco che ci consente di aggiungere facilmente la prenotazione al tuo account come se fosse stata venduta tramite il tuo sito web. Abbiamo aggiunto un esempio di seguito:',
                catalogue_p2: 'Puoi aggiungere l’identificatore della campagna a qualsiasi pagina che la canalizzazione di prenotazione ha da offrire. In questo modo puoi sempre consentire al tuo utente di iniziare ovunque nell’imbuto e personalizzare l’esperienza in base alle sue esigenze.',
                catalogue_p3: 'Non appena un utente arriva sulla pagina a cui è collegata la tua campagna, riceve un indicatore. Questo marcatore si assicura che ogni vendita che questa persona fa pur avendo esso sarà sotto il tuo account. Sii consapevole; nel caso in cui un utente visiti la canalizzazione di prenotazione con una nuova campagna, questo sostituirà l’attuale marker attivo. I marcatori hanno un tempo di recupero di 72 ore dopo di che saranno disattivati. Le prenotazioni effettuate dopo tale periodo non saranno allegate al tuo account fino a quando non visiteranno nuovamente un link con il tuo identificativo.',
                api_p1: 'Bello! Ti stai integrando con l’API ma desideri definire diverse campagne o canalizzazioni attraverso le quali vendi. Puoi facilmente allegare una prenotazione alla campagna. Per questo motivo potresti aver bisogno del tuo personale tecnico di modificare qualcosa nelle richieste che invii alla nostra API. Quando crei una prenotazione stai già comunicando molte informazioni e stiamo aggiungendo un altro pezzo al puzzle. Nella documentazione troverai un parametro chiamato funnel_id. Per questo pezzo di informazioni è necessario disporre di un ID che è possibile inserire.',
                api_p2: 'L’identificatore di questa campagna è:',
                api_p3: 'Dopo aver creato le prenotazioni con questo ID, verranno automaticamente allegate a questa campagna.',
            },
        },
        bookingStats: {
            fields: {
                AUD: 'AUD',
                CHF: 'CHF',
                EUR: 'EUR',
                GBP: 'GBP',
                NZD: 'NZD',
                SEK: 'SEK',
                USD: 'USD',
                amount: 'Quantità',
                bookings: 'Prenotazioni',
                label: 'Data',
                total: 'totale',
            },
            name: 'Statistica',
            title: 'Statistiche di prenotazione',
        },
        discount_codes: {
            actions: {
                create: 'Crea un codice sconto',
                edit: 'Modifica codice sconto: %{title}',
            },
            components: {
                expiry_date: {
                    placeholder: 'Data di scadenza',
                },
                status: {
                    choices: {
                        unused: 'Non utilizzato',
                        used: 'Usato',
                    },
                },
                type: {
                    choices: {
                        multi: 'Multiuso',
                        single: 'Monouso',
                        wallet: 'Portafoglio',
                    },
                },
            },
            fields: {
                amount: 'Importo',
                amount_used: 'Importo utilizzato',
                currency: 'Valuta',
                expiry_date: 'Data di scadenza',
                id: 'ID',
                is_enabled: 'Attivo',
                last_used_at: 'L’ultima volta usato a',
                percentage: 'Percentuale',
                status: 'Stato',
                token: 'Gettone',
                type: 'Tipo',
            },
            title: 'Codici sconto',
        },
        discounts: {
            actions: {
                activate: 'Attivare',
                create: 'Crea uno sconto',
                deactivate: 'Disattivare',
                edit: 'Modifica sconto: %{title}',
                list: 'Lista',
            },
            activity: {
                activate: {
                    title: 'Attivare',
                    description: 'Sei sicuro di voler attivare questo sconto?',
                },
                deactivate: {
                    title: 'Disattivare',
                    description: 'Sei sicuro di voler disattivare questo sconto?',
                },
            },
            fields: {
                accountId: 'Conto',
                amount: 'Importo',
                apply_on_fees: 'Applica alle commissioni',
                created_at: 'Creato in',
                currency: 'Valuta',
                end_processing: 'Fine elaborazione',
                expiry_date: 'Data di scadenza',
                id: 'ID',
                is_enabled: 'Attivo',
                limit: 'Limite',
                percentage: 'Percentuale',
                priority: 'Priorità',
                title: 'Titolo',
                uses_discount_codes: 'Utilizza i codici sconto',
            },
            forms: {
                account: 'Conto',
                discount_codes: 'Codici sconto',
                general: 'Generale',
                manage_discount_codes: 'Codici sconto',
            },
            operators: {
                labels: {
                    and: 'E',
                    equal_or_greater_than: 'Uguale o maggiore di',
                    equal_or_less_than: 'Uguale o minore di',
                    equal: 'È uguale',
                    greater_than: 'Maggiore di',
                    less_than: 'Meno di',
                    not_equal: 'Non è uguale a',
                    or: 'Oppure',
                    within: 'All’interno',
                },
                title: 'Operatore',
            },
            placeholders: {
                email_domain: 'ad es. nu.nl',
            },
            rules: {
                appliance: 'Regole per l’applicazione',
                condition: 'Regole sulle condizioni',
                title: 'Regole dell’applicazione e delle condizioni',
                no_results: 'Non ci sono %{type}',
            },
            types: {
                global: 'Globale',
                regular: 'Regolare',
            },
            title: 'Sconti',
        },
        invitations: {
            actions: {
                accept: {
                    title: 'Accetta invito',
                    description: 'Vuoi accettare questo invito?',
                },
                deny: {
                    title: 'Nega invito',
                    description: 'Vuoi negare questo invito?',
                },
            },
            no_invitations: 'Nessun invito trovato.',
            open_invitations: 'Apri inviti',
            request_title: 'Richieste di invito',
            sent_title: 'Inviti inviati',
            title: 'Inviti',
        },
        invoices: {
            download: 'Scarica fattura',
            export: {
                success: 'Le fatture sono state esportate correttamente.',
                title: 'Esporta fatture',
                lines: {
                    title: 'Esporta righe fattura',
                },
            },
            fields: {
                amount: 'Importo',
                invoiced_at: 'Fatturato presso',
                status: 'Stato',
            },
            show: {
                details: 'Dettagli',
                title: 'Mostra la fattura',
            },
            status: {
                charged_back: 'Rimborso',
                open: 'Aperto',
                overdue: 'Scaduto',
                paid: 'Pagato',
                paid_manually: 'Pagato manualmente',
                processing: 'Processing',
            },
            title: 'Fatture',
        },
        general: {
            fields: {
                boolean: {
                    yes: 'Sì',
                    no: 'No',
                },
            },
        },
        memberships: {
            actions: {
                edit: 'Modifica iscrizione: %{title}',
            },
            fields: {
                concurrency: 'Concorrenza',
                purge_reservations: 'Eliminare le prenotazioni',
                paid_by_invoice: 'Pagato tramite fattura',
            },
            messages: {
                created: {
                    success: 'Iscrizione creata con successo',
                },
                deleted: {
                    success: 'Iscrizione eliminata con successo',
                },
                updated: {
                    success: 'Iscrizione aggiornata con successo',
                },
            },
        },
        membership_schedules: {
            messages: {
                created: {
                    success: 'Piano di abbonamento creato con successo',
                },
                deleted: {
                    success: 'Piano di abbonamento eliminato con successo',
                },
                updated: {
                    success: 'Piano di abbonamento aggiornato con successo',
                },
            },
        },
        no_account: {
            description: 'Per utilizzare la dashboard, devi essere associato a un partner. Uno dei nostri partner potrebbe averti già inviato un invito a iscriverti al proprio account aziendale. Fai clic sul pulsante qui sopra per vedere se hai degli inviti aperti.',
            title: 'Nessun account disponibile',
        },
        orders: {
            actions: {
                check_new_price: 'Controlla il nuovo prezzo',
                csv: 'CSV',
                export: 'Prenotazioni per l’esportazione',
                export_related: 'Prenotazioni per le esportazioni',
                order_email_resent: 'Order email resent',
                resend_email: 'Rinvia l’e-mail',
                retry: 'Riprova',
            },
            amend: {
                message: {
                    availability: 'Questo prodotto non è più disponibile.',
                    payment: {
                        required: 'La differenza di prezzo non include i potenziali costi di transazione.',
                    },
                },
                payment_method: {
                    button: 'Metodo di Pagamento',
                },
                payment_link: {
                    title: 'Il tuo link di pagamento per %{title}:',
                },
                price: {
                    current: 'Vecchio prezzo',
                    new: 'Nuovo prezzo',
                    difference: 'Differenza',
                },
                title: 'Modifica la prenotazione',
            },
            cancel: {
                description: 'Sei sicuro di voler cancellare questa prenotazione?',
                title: 'Cancella la Prenotazione',
            },
            edit: {
                no_longer_editable: 'Queste informazioni non possono più essere modificate nel sistema, si prega di contattare direttamente il fornitore.',
            },
            fields: {
                cancelled_at: 'Annullato a',
                commission: {
                    int_yield_price: 'Rendimento del servizio del rivenditore',
                    mobian_commission_total: 'Totale',
                    mobian_product_commission_price: 'Commissione MOBIAN',
                    mobian_product_yield_commission_price: 'Commissione di rendimento del prodotto',
                    mobian_vat_amount: 'Commissione IVA',
                    mobian_vat_price: 'Totale',
                    price_administration_fee: 'Costi di amministrazione',
                    price_base: 'Prezzo base',
                    price_costfree_cancellation: 'Cancellazione gratuita',
                    price_options: 'Opzioni',
                    provider_total_price: 'Totale parziale',
                    reseller_commission_total: 'Commissione del rivenditore',
                    reseller_product_commission_price: 'Commissione prodotto',
                    reseller_product_price: 'Prenotazione totale',
                    reseller_product_yield_commission_price: 'Commissione di rendimento',
                    reseller_vat_amount: 'IVA',
                    reseller_vat_price: 'Totale',
                },
                country_code: 'Prefisso internazionale',
                created_at: 'Creato a',
                customer_remarks: 'Commenti del cliente',
                destination_address: 'Destinazione',
                destination_arrival_date: {
                    hours: 'ore',
                    label: 'Data d’arrivo',
                    minutes: 'minuti',
                },
                destination_departure_date: {
                    hours: 'ore',
                    label: 'Data di partenza',
                    minutes: 'minuti',
                },
                drop_off_date: 'Data d’inizio',
                ending_at: 'Che finisce alle',
                email: 'E-mail',
                first_name: 'Nome di battesimo',
                flight_number: 'Numero di volo',
                full_name: 'Nome',
                campaigns: 'Campagne',
                is_test: 'Test',
                last_name: 'Cognome',
                license_plate: 'Targa',
                locale: 'Linguaggio',
                location_address: 'Posizione',
                number_of_persons: 'Numero di persone',
                order_id: 'Prenotazione',
                origin_address: 'Partenza',
                payment_amount_paid: 'Importo pagato',
                payment_status: 'Stato del pagamento',
                phone: 'Numero di telefono',
                pick_up_date: 'Data di ritiro',
                price: 'Prezzo',
                product: 'Prodotto',
                provider: 'Fornitore',
                reservation_status: 'Stato della prenotazione',
                return_flight_number: 'Numero di volo di ritorno',
                starting_at: 'A partire da',
                status: 'Stato',
                updated_at: 'Ultimo aggiornamento',
            },
            filters: {
                account_id: {
                    label: 'Account',
                },
                cancelled_at: {
                    label: 'Annullato a',
                    placeholder: 'Annullato a',
                },
                created_at: {
                    label: 'Creato a',
                    placeholder: 'Creato a',
                },
                currencies: {
                    label: 'Valute',
                },
                destination_address: {
                    label: 'Luogo di scarico',
                },
                destination_arrival_date: {
                    label: 'Data d’arrivo',
                    placeholder: 'Inizio (arrivo destinazione)',
                },
                destination_departure_date: {
                    label: 'Data di partenza',
                    placeholder: 'Fine (partenza destinazione)',
                },
                interval: {
                    choices: {
                        date: 'data',
                        day: 'giorno',
                        month: 'mese',
                        week: 'Settimana',
                        year: 'anno',
                    },
                    label: 'Intervallo',
                },
                is_test_order: {
                    choices: {
                        only_real: 'Vero',
                        only_test: 'Test',
                    },
                    label: 'Prenotazioni',
                },
                last_name: 'Cognome',
                payment_status: {
                    choices: {
                        chargedback: 'Ricaricato',
                        deferred: 'Differite',
                        failed: 'Mancato',
                        in_progress: 'In corso',
                        refunded: 'Rimborsato',
                        success: 'Successo',
                        unknown: 'Sconosciuto',
                    },
                    label: 'Stato del pagamento',
                },
                origin_address: {
                    label: 'Posto di raccolta',
                },
                reservation_status: {
                    choices: {
                        canceled: 'Annullato',
                        completed: 'Completato',
                        error: 'Errore',
                        pending: 'In attesa di',
                        split: 'Diviso',
                        under_review: 'In fase di revisione',
                    },
                    label: 'Stato della prenotazione',
                },
            },
            information: {
                consumer_communication: 'Questo cliente non riceve automaticamente le e-mail di prenotazione.',
                multibookings: {
                    split_from: 'This booking belongs to multi-booking ',
                    split_to: 'This booking has been split to ',
                },
                test_booking: 'Questa prenotazione viene creata come un ordine di prova.',
            },
            name: 'Prenotazioni',
            paymentSlip: {
                download: {
                    title: 'Scarica la prova di pagamento',
                },
                send: {
                    description: 'Il consumatore riceve una distinta di versamento contenente ogni aggiornamento, sei sicuro di voler inviare la polizza di versamento manualmente?',
                    success: 'Polizza di versamento inviata',
                    title: 'Invia Distinta di Pagamento',
                },
                title: 'Prova di pagamento',
            },
            receipt: {
                administration_costs: 'Costi amministrativi',
                administration_fees: 'Costi amministrativi',
                base_price: 'Prezzo base',
                costfree_cancellation: 'Cancellazione gratuita',
                membership_deduction: 'Detrazione iscrizione',
                options: 'Opzioni',
                service_yield: 'Rendimento del servizio',
                split_deduction: 'Detrazione frazionata',
                subtotal_additional: 'Subtotale costi aggiuntivi',
                subtotal_base: 'Subtotale',
                subtotal_discounts: 'Subtotale sconti',
                total: 'Totale',
                transaction_fees: 'Costi di transazione',
            },
            retry: {
                description: 'Sei sicuro di voler riprovare questa prenotazione?',
                title: 'Riprova Prenotare',
            },
            show: {
                activities: {
                    booking: {
                        empty: 'Non ci sono attività registrate per questa prenotazione.',
                        label: 'Attività',
                        table: {
                            activity: 'Attività',
                            actor: 'Utente',
                            created_at: 'Data',
                            property: 'Valore',
                            status: 'Stato',
                            target_id: 'Identifier',
                            target_type: 'Bersaglio',
                        },
                    },
                },
                booking_information: 'Informazioni sulla prenotazione',
                paid_on_invoice: 'Questa prenotazione è pagata in fattura.',
                product: 'Prodotto',
                reseller: 'Rivenditore',
                reservation: 'Prenotazione',
                reservation_details: 'Dettagli della prenotazione',
                travel_details: 'Dettagli di viaggio',
            },
            tabs: {
                activities: 'Attività',
                commission: 'Commissione',
                customer: 'Cliente',
                payment: 'Pagamento',
                travel: 'Viaggio',
            },
            voucher: {
                download: {
                    title: 'Download voucher',
                },
                send: {
                    description: 'Il consumatore riceve un voucher per ogni aggiornamento, sei sicuro di voler inviare il voucher manualmente?',
                    success: 'Voucher inviato con successo',
                    title: 'Invia voucher',
                },
                after_alteration: {
                    description: 'Vuoi informare il cliente sugli aggiornamenti?',
                },
                title: 'Voucher',
            },
        },
        password: {
            error: {
                password_current: 'La password non corrisponde alla password esistente.',
            },
            name: 'Cambia la tua password',
            fields: {
                password_current: 'Password attuale',
                password_new: 'Nuova password',
                password_confirmation: 'Conferma la nuova password',
            },
            success: 'La password è stata salvata correttamente.',
        },
        points_of_interest: {
            actions: {
                create: 'Crea un nuovo punto di interesse',
                edit: 'Modifica punto di interesse: %{title}',
                show: 'Punto di interesse: %{title}',
            },
            fields: {
                address: 'Indirizzo',
                city: 'Città',
                country: 'Nazione',
                google_place_id: 'Google Place ID',
                id: 'ID',
                is_highlighted: 'Evidenziato',
                latitude: 'Latitudine',
                location_x: 'Posizione x',
                location_y: 'Posizione y',
                longitude: 'Longitudine',
                name: 'Nome',
                state: 'Stato',
                street: 'Strada',
                street_number: 'Nº',
                type: 'Tipo di POI',
                zipcode: 'Cap',
            },
            import: {
                dropzone: {
                    description: 'Trascina e rilascia o premi importa il tuo file CSV con i nuovi punti di interesse.',
                    title: 'Carica CSV',
                },
                title: 'Importa punti di interesse da CSV',
            },
            promoted_products: {
                add: 'Aggiungi prodotto promosso',
                no_results: 'Non ci sono prodotti in promozione ',
                title: 'Prodotti promossi',
            },
            title: 'Punti di interesse',
            types: {
                accommodation: 'Alloggio',
                airport: 'Aeroporto',
                beach: 'Spiaggia',
                bridge: 'Ponte',
                business_centre: 'Centro affari',
                city: 'Città',
                cultural: 'Culturale',
                education: 'Educazione',
                event: 'Evento',
                event_center: 'Centro eventi',
                government_building: 'Edificio governativo',
                hospital: 'Ospedale',
                library: 'Biblioteca',
                museum: 'Museo',
                neighbourhood: 'Quartiere',
                other: 'Altro',
                park: 'Parco',
                port: 'Porta',
                recreation: 'Ricreazione',
                religious_building: 'Edificio religioso',
                restaurant: 'Ristorante',
                shopping_centre: 'Centro commerciale',
                sight: 'Punto d’interesse',
                station: 'Stazione ferroviaria',
            },
        },
        products: {
            actions: {
                activate: 'Attiva',
                create: 'Crea un prodotto',
                deactivate: 'Disattiva',
                edit: 'Modifica prodotto',
                localisation: 'Contenuto del prodotto',
                occupancy: 'Occupazione',
                resource: 'Risorsa',
            },
            activity: {
                activate: {
                    title: 'Il prodotto è attivato',
                    description: 'Il prodotto è ora reso visibile su tutte le nostre piattaforme.',
                },
                deactivate: {
                    title: 'Il prodotto è disattivato',
                    description: 'Il prodotto non è visibile e l’utente finale non lo vedrà più.',
                },
            },
            administration_fee: {
                title: 'Tariffa amministrativa',
            },
            advancedTimes: {
                title: 'Tempi massimi e minimi avanzati',
                fields: {
                    maximum_advance: 'Tempo massimo avanzato',
                    minimum_advance: 'Tempo minimo avanzato',
                },
            },
            allowed_capacity_excess: {
                title: 'Eccesso di capacità consentito',
                fields: {
                    capacity_excess: 'Eccesso di capacità',
                },
            },
            attribute: 'Attributo',
            availability: {
                button: 'Convalidare',
                dialog: {
                    description: '',
                    title: 'Convalida il prodotto',
                },
                results: {
                    arrival_dates_blocked: 'Date di arrivo bloccate',
                    available_price_information: 'Prezzo disponibile',
                    blocked_dates: 'Date bloccate',
                    capacity: 'Capacità',
                    configuration: 'Configurazione prodotto',
                    consumer_price: 'Prezzo al consumatore',
                    departure_dates_blocked: 'Date di partenza bloccate',
                    has_time_zone: 'Fuso orario corretto',
                    is_visible: 'Prodotto è visibile',
                    maximum_advance: 'Max. Advance',
                    maximum_duration: 'Max. Durata',
                    minimum_advance: 'Min. Advance',
                    minimum_duration: 'Min. Durata',
                    operational_times: 'Orari operativi',
                    pricing_service_price: 'Prezzo del servizio prezzi',
                    product_enabled: 'Prodotto attivo',
                    provider_enabled: 'Provider attivo',
                    provider_price: 'Prezzo del fornitore',
                    supported_currency: 'Valuta supportata',
                    supported_resource: 'Le impostazioni delle risorse sono corrette',
                    valid_price: 'Prezzo valido',
                },
            },
            arrival_dates_blocked: {
                title: 'Arrivo bloccato',
                add: 'Aggiungi un arrivo bloccato',
                no_result: 'Non sono state trovate date di arrivo bloccate',
            },
            blocked_dates: {
                title: 'Date bloccate',
                add: 'Aggiungi data bloccata',
                no_result: 'Non sono state trovate date bloccate',
            },
            capacity: {
                title: 'Capacità',
            },
            configuration: {
                saved: 'La configurazione del prodotto è stata salvata correttamente.',
            },
            count: 'Conteggio',
            departure_dates_blocked: {
                title: 'Date di partenza bloccate',
                add: 'Aggiungi date bloccate',
                no_result: 'Non sono state trovate date di partenza bloccate',
            },
            duration: {
                no_duration: 'Nessuna durata massima o minima trovata per questo prodotto.',
                fields: {
                    maximum_duration: 'Durata massima',
                    minimum_duration: 'Durata minima',
                },
                placeholders: {
                    duration: 'ad esempio 10g o 12o',
                    duration_day: 'ad esempio 10g',
                    duration_hour: 'ad esempio 12o',
                },
                response: {
                    save: 'I tempi di durata sono stati salvati correttamente',
                },
            },
            edit: {
                location: 'Modifica posizione',
                resource: 'Modifica risorsa',
            },
            fields: {
                active: 'Attivo',
                administration_fee: {
                    maximum: 'Massimo',
                    maximum_placeholder: 'ad esempio 1.99, 2.50',
                    minimum: 'Minimo',
                    minimum_placeholder: 'ad esempio 1.99, 2.50',
                    percentage: 'Percentuale',
                    percentage_placeholder: 'ad esempio 0.10 (10%), 0.03 (3%)',
                },
                allow_overstay: 'Consenti sforamento',
                category_id: 'Categoria',
                city: 'Città',
                communicate_email_addresses: 'Comunicare gli indirizzi email',
                company_id: 'Fornitore',
                conditionz: 'Termini & Condizioni',
                configuration: 'Configurazione',
                country_code: 'Prefisso internazionale',
                country: 'Paese',
                date: 'Data',
                description_de: 'Descrizione Tedesca',
                description_en: 'Descrizione Inglese',
                description_es: 'Descrizione Spagnola',
                description_fr: 'Descrizione Francese',
                description_it: 'Descrizione Italiana',
                description: 'Descrizione Olandese',
                duration: 'Durata massima e minima',
                email_domain: 'Dominio di e-mail',
                email_from: 'Invia email da',
                email1: 'Fornitore di indirizzi e-mail',
                email2: 'Indirizzo email admin',
                enabled: 'Attivo',
                freeze_period: 'Periodo di congelamento',
                from: 'De',
                icon: 'Icon',
                id: 'ID',
                inactive: 'Non attivo',
                internal_qr_code: 'Codice QR interno',
                is_combined: 'Prodotto combinato',
                is_official_facility: 'Questa è una struttura ufficiale',
                is_visible: 'Visibile',
                key: 'Chiave',
                leeway: 'Spazio di arrivo e partenza',
                location_address: 'Indirizzo',
                location_id: 'ID della posizione',
                location_latitude: 'Latitudine',
                location_longitude: 'Longitudine',
                logo: 'Logo',
                mail_de: 'Email scritta in Tedesco',
                mail_en: 'Email scritta in Inglese',
                mail_fr: 'Email scritta in Francese',
                mail: 'Email scritta in Olandese',
                map_image: 'Immagine di posizione',
                number_of_persons: 'Numero di persone',
                operational_times: 'Orari di funzionamento',
                options: 'Opzioni',
                parking_id: 'ID parcheggio',
                phone: 'Numero di telefono',
                point_of_interest_id: 'Point of interest',
                priority: 'Priority',
                product_id: 'Fornitore',
                property_id: 'Proprietà',
                provider_id: 'Fornitore',
                radius: 'Raggio',
                rating: 'Valutazione',
                resource: {
                    id: 'ID Risorsa',
                    name: 'Nome della risorsa',
                },
                service_id: 'Servizio',
                split_percentage: 'Percentuale di prezzo suddiviso',
                street: 'Strada',
                subcategory_id: 'Subcategory',
                terms_and_conditions: {
                    title: 'Termini e condizioni',
                    link: 'URL',
                    link_placeholder: 'Inserisci l’URL',
                    name: 'Nome',
                    name_placeholder: 'Inserisci il nome',
                },
                title: 'Titolo',
                to: 'A',
                type: 'Genere',
                updated_at: 'Aggiornato a',
                value: 'Valore',
                vat_percentage: 'Percentuale IVA',
                voucher_include_invoice: 'Il voucher include la fattura',
                weekday: 'Giorno',
                zipcode: 'CAP',
            },
            filters: {
                radius: {
                    '5': '5km',
                    '10': '10km',
                    '15': '15km',
                    '20': '20km',
                    '25': '25km',
                },
            },
            forms: {
                access_methods: 'Metodi di accesso',
                content: 'Soddisfare',
                general: 'Generale',
                location: 'Posizione',
                logo: 'Logo',
                preferences: 'Preferenze',
                properties: 'Proprietà',
                provider: 'Provider',
                related: 'Relazionato',
            },
            freeze_period: {
                placeholder: 'ad esempio. 2h',
            },
            leeway: {
                fields: {
                    leeway_arrival: 'Spazio di arrivo',
                    leeway_departure: 'Spazio di partenza',
                },
                placeholders: {
                    leeway: 'ad es. 30 (min)',
                },
            },
            logo: {
                description: 'Max 300px alto, Max 300px di larghezza',
            },
            name: 'Prodotto',
            notifications: {
                configuration: 'Questo prodotto non presenta configurazioni. Vai alla pagina di configurazione per modificare la configurazione del prodotto.',
                inactive: 'Questo prodotto è inattivo. Fare clic sul pulsante di attivazione per attivare il prodotto.',
                product_missing_data: 'A questo prodotto mancano i dati di configurazione e/o le risorse. Fornisci i dati, quindi riprova ad attivare il prodotto.',
                'product-missing-data-for-enable': 'Nel prodotto mancano i dati di configurazione e/o le risorse.',
                resource: 'A questo prodotto manca una risorsa. Vai alla pagina delle risorse per modificare la risorsa del prodotto.',
                vat_percentage: 'A questo prodotto manca una percentuale IVA applicata nelle configurazioni del prodotto. Vai alla pagina di configurazione per modificare la percentuale IVA.',
            },
            number_of_persons: {
                placeholder: 'Numero massimo di persone',
            },
            operational_times: {
                add: 'Aggiungi il tempo di funzionamento',
                no_result: 'Non ci sono tempi di funzionamento in questo prodotto.',
                save: 'Risparmia i tempi di funzionamento',
                title: 'Orari di funzionamento',
            },
            occupancy: {
                graph: {
                    label: {
                        capacity: 'Capacità',
                        hour: {
                            capacity: 'Capacità oraria',
                            occupancy: 'Occupazione oraria',
                        },
                        occupancy: 'Occupazione',
                    },
                    no_results: 'Nessun prodotto è stato prenotato nella data selezionata.',
                    title: 'Occupazione',
                },
                reservations: {
                    destination_arrival_date: {
                        no_results: 'Non sono state trovate prenotazioni in arrivo per la data selezionata.',
                        title: 'Prenotazioni in arrivo (%{count})',
                    },
                    destination_departure_date: {
                        no_results: 'Non sono state trovate prenotazioni in partenza per la data selezionata.',
                        title: 'Prenotazioni in partenza (%{count})',
                    },
                    id: {
                        no_results: 'Non sono state trovate altre prenotazioni per la data selezionata.',
                        title: 'Altre prenotazioni (%{count})',
                    },
                },
            },
            title: 'Prodotti',
            properties: {
                no_results: 'Non ci sono proprietà aggiunte a questo prodotto.',
            },
            related: {
                add: 'Aggiungi un prodotto correlato',
                delete: {
                    description: 'L’oggetto sarà rimosso in modo permanente. Questa azione non può essere annullata.',
                    title: 'Sei sicuro di voler cancellare questo?',
                },
                no_results: 'Non ci sono prodotti correlati',
                title: 'Relazionato',
            },
            require_one_of: {
                add: 'Aggiungi un prodotto correlato richiesto',
                no_result: 'Non ci sono prodotti correlati richiesti',
                title: 'Richiedi uno di',
            },
            rules: 'Regole',
            sales_price: {
                add: 'Aggiungi una proprietà con prezzo di vendita',
                no_result: 'Non ci sono configurazioni dei prezzi di vendita',
                title: 'Prezzo di vendita',
            },
            pages: {
                location: 'Modifica la posizione: %{title}',
                resource: 'Modifica la risorsa: %{title}',
            },
            value: {
                add: 'Aggiungi un %{type}',
                label: 'Valore',
                no_result: 'Non ci sono %{type} in questa configurazione.',
                save: 'Memorizzare la %{type}',
                title: 'Valore',
                types: {
                    dates: {
                        plural: 'date',
                        singular: 'data',
                    },
                    email_domain: {
                        plural: 'domini di e-mail',
                        singular: 'dominio di e-mail',
                    },
                    time: {
                        plural: 'volte',
                        singular: 'volta',
                    },
                },
            },
            communicate_email_addresses: {
                placeholder: 'Scegli se comunicare gli indirizzi email',
                choices: {
                    do_not_send: 'Non inviare',
                    send: 'Invia',
                    send_masked: 'Invia mascherato',
                },
            },
            voucher_include_invoice: {
                placeholder: 'p. ej. sì o no',
            },
        },
        product_memberships: {
            actions: {
                create: 'Crea un’adesione al prodotto',
                edit: 'Modifica l’adesione al prodotto',
            },
            create: {
                pricing: 'Utilizzeremo il prezzo predefinito dell\'abbonamento al prodotto se non aggiorni il campo del prezzo.',
            },
            fields: {
                group_identifier: 'Identificatore di gruppo',
                membership_schedule: 'Programma',
                price_ondemand: 'Prezzo su richiesta',
                price_scheduled: 'Prezzo programmato',
                product_membership_id: 'Iscrizione al prodotto',
                supports_ondemand: 'Supporta on-demand',
                supports_scheduled: 'Supporta la programmazione',
                user_product_membership_pool_id: 'Pool di iscrizione',
                user_vehicle_id: 'Veicolo',
                deferred: 'Differito',
                payment_method_description: 'Per impostazione predefinita, il metodo di pagamento è impostato su Fattura. Se si desidera utilizzare il pagamento differito, selezionare la casella di controllo qui sotto.',
            },
            no_results: 'Non ci sono iscrizioni ai prodotti',
            title: 'Iscrizioni ai prodotti',
        },
        profile: {
            name: 'Profilo',
        },
        properties: {
            actions: {
                create: 'Crea una proprietà',
                edit: 'Modifica la proprietà',
                show: 'Proprietà: %{title}',
            },
            fields: {
                icon: 'Icona',
                name: 'Nome',
                priority: 'Priorità',
                property_group_id: 'Gruppo di proprietà',
            },
            languages: {
                label: 'Seleziona una lingua disponibile',
            },
            title: 'Proprietà',
            validate: {
                property_group_id: 'Inserisci un gruppo di proprietà',
                'property-groups-not-available': 'Il gruppo di proprietà non è disponibile.',
            },
        },
        propertygroups: {
            actions: {
                create: 'Crea un gruppo di proprietà',
                edit: 'Modifica il gruppo di proprietà: %{title}',
                show: 'Gruppo di proprietà: %{title}',
            },
            fields: {
                id: 'ID',
                name: 'Nome',
                properties: 'Proprietà',
                property: 'Proprietà',
            },
            languages: {
                label: 'Seleziona una lingua disponibile',
            },
            name: 'Gruppo di proprietà',
            plural: 'Gruppi di proprietà',
        },
        reservations: {
            fields: {
                booking_order_id: 'ID MOBIAN client',
                cancelled_at: 'Annullato alle',
                created_at: 'Creato',
                customer: 'Cliente',
                customer_remarks: 'Commenti dei clienti',
                destination_address: 'Luogo di scarico',
                destination_arrival_date: 'Data d’arrivo',
                destination_departure_date: 'Data di partenza',
                drop_off_date: 'Data di riconsegna',
                ending_at: 'Che finisce alle',
                flight_number: 'Numero di volo',
                full_name: 'Nome',
                internal_order_id: 'ID ordine',
                last_name: 'Cognome',
                license_plate: 'Targa',
                number_of_persons: 'Numero di persone',
                origin_address: 'Posto di raccolta',
                phone: 'Telefono',
                pick_up_date: 'Data di ritiro',
                product: 'Prodotto',
                remote_reference: 'Riferimento remoto',
                return_flight_number: 'Numero del volo di ritorno',
                starting_at: 'A partire da',
                subscription_id: 'ID abbonamento',
                subscription_reservation_id: 'ID prenotazione abbonamento',
                updated_at: 'Ultimo aggiornamento',
            },
            name: 'Prenotazione',
            open_barrier: {
                modal: {
                    error: 'Ops, si è verificato un errore durante l’apertura della barriera. Riprova più tardi.',
                    force_not_allowed_for_access_method: 'La barriera non è consentita per questo metodo di accesso.',
                    session_open_barrier_requires_access_point: 'L’apertura della barriera in questa sessione richiede un punto di accesso.',
                    success: 'La barriera è stata aperta con successo.',
                },
                title: 'Apri la barriera',
            },
            title: 'Prenotazioni',
            session: {
                asset_not_usable: {
                    description: 'Puoi riprovare con un arresto forzato. Questo terminerà sempre la sessione e riporterà l’asset a « disponibile » se la sessione è stata avviata con uno.',
                    title: 'L’arresto della sessione non è riuscito a causa dei seguenti prerequisiti:',
                },
                button: {
                    end: 'Ferma la seduta',
                    start: 'Inizia la sessione',
                    open_barrier: 'Apri la barriera',
                },
                modal: {
                    button: {
                        submit: {
                            end: 'Ferma la seduta',
                            start: 'Inizia la sessione',
                        },
                    },
                    callback: {
                        end: {
                            error: 'Si è verificato un problema durante la conclusione della sessione. Per favore riprova più tardi',
                            success: 'La sessione è stata terminata con successo.',
                        },
                        start: {
                            error: 'Si è verificato un problema durante l’avvio della sessione. Per favore riprova più tardi',
                            success: 'La sessione è stata avviata con successo.',
                        },
                    },
                    checkbox: 'Apri il cancello',
                    description: {
                        end: 'La sessione di prenotazione corrente è già iniziata. Fare clic sulla casella di controllo se si desidera aprire o chiudere il cancello.',
                        start: 'La sessione di prenotazione corrente non è ancora iniziata. Fare clic sulla casella di controllo se si desidera aprire o chiudere il cancello.',
                    },
                    title: {
                        end: 'Ferma la seduta',
                        start: 'Inizia la sessione',
                    },
                },
            },
            show: {
                activities: {
                    access_sessions: {
                        title: 'Accesso alle sessioni',
                        not_found: 'Nessuna attività di sessione di accesso trovata per questa prenotazione',
                    },
                },
                booking_information: 'Informazioni sulla prenotazione',
                product: 'Prodotto',
                reservation_details: 'Dettagli della prenotazione',
                reservation_price: 'Prezzo della prenotazione',
                travel_details: 'Dettagli di viaggio',
            },
        },
        subscriptions: {
            actions: {
                create: 'Creare',
                edit: 'Modifica',
            },
            fields: {
                account: 'Conto',
                company_name: 'Nome dell’azienda',
                currency: 'Valuta',
                email: 'Email',
                end_date: 'Data di fine',
                first_name: 'Nome',
                full_name: 'Nome completo',
                last_name: 'Nome e cognome',
                language: 'Lingua',
                license_plate: 'Targa',
                name: 'Nome',
                order_id: 'Ordine ID',
                phone: 'Telefono',
                price: 'Prezzo',
                start_date: 'Data di inizio',
                status: 'Stato',
                terminated_at: 'Terminato a',
            },
            show: {
                subscription_details: 'Dettagli dell’abbonamento',
                subscription: 'Sottoscrizione',
            },
            tooltips: {
                ok: 'Ok',
                pending: 'Sottoscrizione: in sospeso',
                under_review: 'Abbonamento: in corso di revisione',
            },
            title: 'Abbonamenti',
        },
        subscriptionProducts: {
            create: {
                title: 'Aggiungi prodotto in abbonamento',
            },
            fields: {
                end_time: 'Tempo scaduto',
                start_time: 'Ora di inizio',
                day: 'Giorno',
                product: 'Prodotto',
            },
            input: {
                day: {
                    1: 'Lunedi',
                    2: 'Martedì',
                    3: 'Mercoledì',
                    4: 'Giovedi',
                    5: 'Venerdì',
                    6: 'Sabato',
                    7: 'Domenica',
                },
            },
            no_results: 'Non sono stati trovati prodotti di abbonamento.',
            title: 'Prodotti per abbonamento',
        },
        subcategories: {
            actions: {
                create: 'Crea una sottocategoria',
                edit: 'Modifica la sottocategoria',
                show: 'Sottocategoria: %{title}',
            },
            fields: {
                id: 'ID',
                name: 'nome',
                category_id: 'categoria',
            },
            languages: {
                label: 'Seleziona una lingua disponibile',
            },
            title: 'Sottocategorie',
            validate: {
                'categories-not-available': 'Non ci sono categorie disponibili.',
            },
        },
        users: {
            actions: {
                activate: 'Attivare',
                create: 'Crea un utente',
                deactivate: 'Disattiva',
                edit: 'Edit User',
                reset_password: 'Reimposta password',
            },
            activity: {
                activate: {
                    title: 'L’utente verrà attivato',
                    description: 'Quando l’utente è attivo, l’utente può accedere ai nostri dashboard, app e utilizzare i nostri servizi.',
                },
                deactivate: {
                    title: 'L’utente verrà disattivato',
                    description: 'Quando l’utente è inattivo, l’utente non può più accedere ai nostri dashboard, app o utilizzare i nostri servizi.',
                },
            },
            delete: {
                warnings: {
                    'user-has-active-memberships': 'Esistono iscrizioni attive per questo utente.',
                    'user-has-active-subscriptions': 'Esistono abbonamenti attivi per questo utente.',
                    'user-has-future-bookings': 'Esistono prenotazioni future per questo utente.',
                    'user-has-invoicable-bookings': 'Esistono prenotazioni fatturabili per questo utente.',
                    'user-has-open-invoices': 'Esistono fatture aperte per questo utente.',
                    'user-has-overdue-invoices': 'Esistono fatture scadute per questo utente.',
                    'user-has-recent-recurring-payment-activity': 'Esiste un’attività recente di pagamento ricorrente per questo utente.',
                    'user-has-wallet-funds': 'Esistono fondi nel portafoglio per questo utente.',
                },
            },
            fields: {
                active: 'Attivo',
                address: 'Indirizzo',
                bic: 'BIC',
                city: 'Città',
                company_email: 'Email aziendale',
                company_name: 'Nome della ditta',
                company_registration: 'Numero COC',
                company_vat: 'Partita IVA',
                contract: 'Contrarre',
                country: 'Nazione',
                email: 'E-mail',
                external_yield: 'Rendimento esterno',
                firstname: 'Nome di battesimo',
                iban: 'IBAN',
                lastname: 'Cognome',
                locale: 'Locale',
                logo: 'Logo',
                membership_id: 'Iscrizione',
                name: 'Nome',
                orders: 'Ordini',
                phonenumber: 'Telefono',
                product_commission_reseller: 'Commissione prodotto rivenditore',
                provider_id: 'Provider',
                reseller_id: 'Reseller',
                role: 'Ruolo',
                title: 'Titolo',
                url: 'URL',
                user_id: 'Reseller',
                username: 'Nome utente',
                vat: 'IVA',
                yield_commission: 'Commissione di rendimento',
                zipcode: 'Cap',
            },
            filters: {
                active: {
                    active: 'Solo attivo',
                    inactive: 'Solo inattivo',
                },
            },
            forms: {
                account: 'Account',
                address: 'Indirizzo',
                company: 'Azienda',
                contact: 'Contatto',
                general: 'Generale',
                products: 'Prodotti attivi aggiornati per ultimi',
                registrations: 'Iscrizioni',
            },
            memberships: {
                create: 'Creazione dell’iscrizione utente',
                edit: 'Modifica dell’appartenenza utente (%{name})',
                no_results: 'Non ci sono abbonamenti collegati a questo utente',
                pricing: 'Prezzi',
            },
            name: 'Utente',
            no_results: 'Non sono stati trovati utenti.',
            not_found: 'Nessun utente trovato.',
            notifications: {
                inactive: 'Questo utente è inattivo. Fare clic sul pulsante di attivazione per riattivare l’utente.',
                not_confirmed: 'Questo utente non ha ancora confermato il proprio account.',
            },
            title: 'Utenti',
            products: {
                actions: {
                    list: 'Mostra tutti i prodotti (%{total})',
                },
            },
            // User-product-memberships create and edit
            product_memberships: {
                actions: {
                    create: 'Crea un’iscrizione al prodotto utente',
                    edit: 'Modifica l’iscrizione al prodotto utente',
                },
            },
            reset_password: {
                description: 'La reimpostazione di una password invierà una nuova password all’e-mail dell’utente. La vecchia password non sarà più utilizzabile. Le sessioni attualmente registrate di questo utente richiederanno loro di accedere su tutti i dispositivi con la loro nuova password.',
                title: 'Reimposta la password dell’utente',
            },
            roles: {
                reseller: 'Rivenditore',
                provider: 'Provider',
            },
        },
        wallets: {
            fields: {
                amount: 'Importo',
                balance: 'Saldo',
                reason: 'Motivo',
                type: 'Tipo',
            },
            no_results: 'Non sono stati trovati portafogli',
            title: 'Portafogli',
            topup: {
                notifications: {
                    success: {
                        decrease: 'Il portafoglio utente è stato ridotto con successo.',
                        increase: 'Il portafoglio utente è stato aumentato con successo.',
                    },
                },
                label: 'Ricarica',
                title: 'Ricarica del portafoglio',
            },
        },
        webhooks: {
            actions: {
                create: 'Crea un Webhook',
                edit: 'Modifica Webhook: %{title}',
            },
            fields: {
                action_booking_cancelled: 'Prenotazione Azione Annullata',
                action_booking_created: 'Prenotazione Dell’azione Creata',
                action_booking_initialised: 'Prenotazione D’azione Inizializzata',
                action_booking_modified: 'Prenotazione Dell’azione Modificata',
                action_booking_under_review: 'Prenotazione D’azione In Corso Di Revisione',
                action_reservation_cancelled: 'Prenotazione Azione Annullata',
                action_reservation_created: 'Prenotazione Dell’azione Creata',
                action_reservation_modified: 'Prenotazione Dell’azione Modificata',
                is_active: 'Attivo',
                name: 'nome',
                url: 'url',
            },
            forms: {
                actions: 'Azioni',
                general: 'Generale',
            },
            title: 'Webhooks',
        },
    },
    page: {
        page_not_found: {
            title: 'pagina non trovata',
            description: 'La pagina che stai cercando non è stata trovata.',
        },
        resource_not_found: {
            description: 'Non siamo riusciti a trovare la risorsa che stai cercando.',
            title: 'Risorsa non trovata',
        },
        not_authorised: {
            title: 'Spiacenti',
            description: 'Sembra che non sei autorizzato a vedere questa pagina.',
        },
    },
    release: {
        list: {
            description: 'In questa versione abbiamo aggiornato gli elementi visivi per le pagine degli elenchi. Abbiamo rimosso il pulsante Mostra e reso possibile il passaggio del mouse e fare clic sulla riga per essere ridimensionati alla pagina dei dettagli per quell’elemento specifico.',
            title: 'Piccolo aggiornamento alle nostre pagine di panoramica',
        },
    },
    signUp: {
        errors: {
            passowrd_chars: 'La password deve contenere almeno 6 caratteri',
            same_email: 'Le e-mail devono essere uguali',
            same_password: 'Le password devono essere uguali',
        },
        fields: {
            confirm_email: 'Conferma e-mail',
            confirm_password: 'Conferma password',
        },
        no_account: 'Non ho un account',
        title: 'Registrare',
        success: 'L’utente è stato registrato con successo',
    },
};



// WEBPACK FOOTER //
// ./src/i18n/it.js